// All error codes, not necessarily only Http errors
export const enum Errors {
  UNKNOWN_ERROR = 1,

  // Http/Api Errors
  NOT_FOUND = 404,
  SERVER_ERROR = 500,
  FORBIDDEN = 403,
}
